import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-9fc8e4ec"), n = n(), _popScopeId(), n); };
var _hoisted_1 = {
    key: 0,
    class: "sm:hidden"
};
var _hoisted_2 = ["disabled", "selected", "value"];
var _hoisted_3 = ["tabindex", "onClick"];
var _hoisted_4 = { class: "mx-auto my-0 px-3" };
var _hoisted_5 = {
    key: 0,
    class: "e-tabs__hint"
};
var _hoisted_6 = {
    key: 1,
    class: "e-tabs__count"
};
import { computed, onMounted, ref, watch } from 'vue';
import Auth from '@common/modules/auth';
import ETooltip from '@common/ui/ETooltip.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ETabs',
    props: /*#__PURE__*/ _mergeModels({
        tabs: {},
        defaultKey: {},
        type: { default: 'primary' },
        size: { default: 'md' },
        tooltipPosition: { default: 'top' },
        disabled: { type: Boolean, default: false },
        fullsizeButtons: { type: Boolean, default: false },
        adaptive: { type: Boolean, default: true }
    }, {
        "modelValue": {},
        "modelModifiers": {},
    }),
    emits: /*#__PURE__*/ _mergeModels(["change", "input"], ["update:modelValue"]),
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var sizeToClass = {
            'sm': 'text-base',
            'md': 'text-base',
            'lg': 'text-lg',
            'xl': 'text-xl',
        };
        var emits = __emit;
        var props = __props;
        var modelValue = _useModel(__props, "modelValue");
        onMounted(function () {
            if (props.defaultKey) {
                localActiveKey.value = props.defaultKey;
            }
            else {
                localActiveKey.value = modelValue.value ? modelValue.value : props.tabs[0].value;
            }
        });
        watch(modelValue, function (value) {
            if (value) {
                localActiveKey.value = value;
            }
        });
        var localActiveKey = ref('');
        var sizeClasses = computed(function () { return sizeToClass[props.size] || ''; });
        var sizeClass = computed(function () { return "e-tabs--".concat(props.size); });
        var typeClass = computed(function () { return "e-tabs--".concat(props.type); });
        var accessedTabs = computed(function () {
            return props.tabs.filter(function (t) { return t.action ? Auth.hasActions([t.action]) : true; });
        });
        var onTabClick = function (event, item) {
            event.preventDefault();
            if (props.disabled || item.disabled) {
                return;
            }
            var tabKey = item.value;
            if (props.defaultKey && !modelValue.value) {
                localActiveKey.value = tabKey;
            }
            modelValue.value = tabKey;
            emits('change', tabKey);
            // Для работы v-model
            emits('input', tabKey);
        };
        var onSelectChange = function (event) {
            var tabKey = event.target.value;
            if (props.disabled) {
                return;
            }
            if (props.defaultKey && !modelValue.value) {
                localActiveKey.value = tabKey;
            }
            modelValue.value = tabKey;
            emits('change', tabKey);
            // Для работы v-model
            emits('input', tabKey);
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", null, [
                (_ctx.adaptive)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("select", {
                            class: "block w-full focus:ring-primary focus:border-primary outline-none border-gray-300 px-4 py-2 rounded-md bg-gray-100",
                            name: "tabs",
                            onChange: onSelectChange
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accessedTabs.value, function (item) {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: item.value,
                                    disabled: item.disabled,
                                    selected: localActiveKey.value === item.value,
                                    value: item.value,
                                    tabindex: "0"
                                }, _toDisplayString(item.name), 9, _hoisted_2));
                            }), 128))
                        ], 32)
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", {
                    class: _normalizeClass(_ctx.adaptive ? 'hidden sm:block' : 'block')
                }, [
                    _createElementVNode("div", {
                        class: _normalizeClass([[
                                typeClass.value,
                                sizeClass.value,
                                sizeClasses.value,
                                _ctx.fullsizeButtons && 'e-tabs--fullsize-buttons'
                            ], "e-tabs"])
                    }, [
                        _createElementVNode("nav", {
                            class: _normalizeClass([[
                                    sizeClasses.value
                                ], "e-tabs__nav"]),
                            "aria-label": "Tabs"
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accessedTabs.value, function (item) {
                                return (_openBlock(), _createBlock(ETooltip, {
                                    key: item.value,
                                    disabled: !item.tooltip || item.tooltip.length === 0,
                                    "tooltip-text": item.tooltip,
                                    trigger: "hover",
                                    unselectable: ""
                                }, {
                                    default: _withCtx(function () { return [
                                        _createElementVNode("a", {
                                            class: _normalizeClass([[
                                                    localActiveKey.value === item.value && 'e-tab--active',
                                                    item.disabled && 'e-tab--disabled',
                                                ], "e-tab flex items-center whitespace-nowrap"]),
                                            tabindex: localActiveKey.value === item.value ? -1 : 0,
                                            onClick: function ($event) { return (onTabClick($event, item)); }
                                        }, [
                                            _renderSlot(_ctx.$slots, "tab-icon-".concat(item.value)),
                                            _createElementVNode("span", _hoisted_4, _toDisplayString(item.name), 1),
                                            (item.hint !== undefined)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(item.hint), 1))
                                                : _createCommentVNode("", true),
                                            (item.count && item.count > 0)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(item.count), 1))
                                                : _createCommentVNode("", true)
                                        ], 10, _hoisted_3)
                                    ]; }),
                                    _: 2
                                }, 1032, ["disabled", "tooltip-text"]));
                            }), 128))
                        ], 2)
                    ], 2)
                ], 2)
            ]));
        };
    }
});
